import * as React from "react"
import { toast as sonnerToast, Toaster } from "sonner"

function toast(opts) {
  const id = opts.id || undefined;
  
  return sonnerToast(opts.title, {
    id: id,
    description: opts.description,
    action: opts.action
      ? {
          label: opts.action.label,
          onClick: opts.action.onClick,
        }
      : undefined,
    variant: opts.variant,
    duration: opts.duration === Infinity ? Infinity : (opts.duration || 4000),
    onDismiss: opts.onDismiss,
    onAutoClose: opts.onAutoClose,
    closeButton: true,
  })
}

function dismiss(toastId) {
  sonnerToast.dismiss(toastId);
}

// A hook to use the toast function
function useToast() {
    return { toast, dismiss };
}

export { useToast, toast, dismiss, Toaster }